module.exports = __webpack_public_path__ + "static/media/new-market.892d3d98.svg";